import { cn } from '@/utils/style';
import React from 'react';

function Skeleton(props: {
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
}) {
  return (
    <div
      className={cn('relative overflow-hidden rounded-[4px] bg-gray-200', props.className)}
      style={{
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer-custom 1.5s ease-in-out infinite',
        ...props.style,
      }}
      aria-label={props['aria-label']}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes shimmer-custom {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `,
        }}
      />
    </div>
  );
}

export { Skeleton };
